import { Component } from '@angular/core';
import { AbstractWidgetComponent, WidgetStyle } from '@sdbn/common';

@Component({
    selector: 'app-area-gate-log-administration-widget',
    templateUrl: './area-gate-log-administration.component.html',
    styleUrls: ['./area-gate-log-administration.component.scss'],
    standalone: false
})
export class AreaGateLogAdministrationWidgetComponent extends AbstractWidgetComponent {

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
